import styled from 'styled-components';
import { getPartnerPrimaryColor } from 'common/styles/organisationPartnerTheme';

const MIN_HEIGHT = {
  tile: '120px',
  page: '60vh',
  app: '100vh'
};

// A tile replaces a widget card, so it carries the card's own surface (the one
// in home/Widget); a page sits on the page's background; the app owns the viewport.
const SURFACE = {
  tile: theme => theme.colors.white,
  page: () => 'transparent',
  app: theme => theme.colors.greyXXXL
};

export const FallbackContainer = styled.div`
  height: 100%;
  min-height: ${props => MIN_HEIGHT[props.variant]};
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: ${props => (props.variant === 'tile' ? '8px' : '12px')};
  padding: ${props => (props.variant === 'tile' ? '12px' : '32px 16px')};
  box-sizing: border-box;
  background: ${props => SURFACE[props.variant](props.theme)};
  border: ${props => (props.variant === 'tile' ? `1px solid ${props.theme.colors.borderGray}` : 'none')};
  border-radius: ${props => (props.variant === 'tile' ? '4px' : '0')};
  animation: errorFallbackRise 200ms ease-out;

  @keyframes errorFallbackRise {
    from { opacity: 0; transform: translateY(6px); }
    to { opacity: 1; transform: translateY(0); }
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const LogoSlot = styled.div`
  margin-bottom: 8px;
`;

export const FallbackTitle = styled.div`
  font-weight: 700;
  font-size: ${props => (props.variant === 'tile' ? '13px' : '18px')};
  color: ${props => props.theme.colors.greyXXD};
`;

export const FallbackMessage = styled.div`
  max-width: 360px;
  font-size: 13px;
  line-height: 1.5;
  color: ${props => props.theme.colors.greyText};
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
`;

const buttonCss = `
  display: inline-flex;
  align-items: center;
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  border-radius: 7px;
  padding: 7px 14px;
  cursor: pointer;
  box-sizing: border-box;
`;

export const PrimaryAction = styled.button`
  ${buttonCss}
  background: ${props => getPartnerPrimaryColor(props.theme)};
  border: 1px solid ${props => getPartnerPrimaryColor(props.theme)};
  color: ${props => props.theme.colors.white};

  &:hover { filter: brightness(0.93); }
`;

export const GhostAction = styled.button`
  ${buttonCss}
  background: transparent;
  border: 1px solid ${props => props.theme.colors.grey};
  color: ${props => props.theme.colors.greyXXD};

  &:hover { background: ${props => props.theme.colors.greyXL}; }
`;

export const ReferenceButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 2px;
  padding: 2px 6px;
  border: none;
  border-radius: 4px;
  background: transparent;
  font-family: inherit;
  font-size: 11px;
  color: ${props => props.theme.colors.greyText};
  cursor: pointer;

  &:hover { background: ${props => props.theme.colors.greyXL}; color: ${props => props.theme.colors.greyXXD}; }

  svg { width: 11px; height: 11px; }
`;

export const CopiedNote = styled.span`
  margin-left: 2px;
  font-weight: 600;
  color: ${props => props.theme.colors.greyXXD};
`;
